import type { Component, ComponentProps, Snippet } from "svelte"

export class RenderComponentConfig<T extends Component> {
  constructor(
    public component: T,
    public props: ComponentProps<T> | Record<string, unknown> = {}
  ) {}
}

export class RenderSnippetConfig<TParams> {
  constructor(
    public snippet: Snippet<[TParams]>,
    public params: TParams
  ) {}
}

export function renderComponent<T extends Component>(
  component: T,
  props: ComponentProps<T> | Record<string, unknown> = {}
) {
  return new RenderComponentConfig(component, props)
}

export function renderSnippet<TParams>(
  snippet: Snippet<[TParams]>,
  params: TParams
) {
  return new RenderSnippetConfig(snippet, params)
}
